<template>
    <div class="block-editor user-input payload" v-if="payload">
        <div class="user-input-header">
            <span
                class="material-icons"
                v-tippy="{ followCursor: true, placement: 'top-center' }"
                content="Keywords is a matching system in ChatBot. It works great when you want a unique phrase or a word to trigger a bot response."
            >
                help_outline
            </span>
            Keywords
        </div>
        <div class="keywords">
            <input
                @blur="onBlur"
                @focus="showPlaceholder = i"
                maxlength="50"
                :class="{ filled: !!payload.keywords[i].length }"
                class="keyword"
                style="max-width: fit-content"
                type="text"
                v-for="(k, i) in payload.keywords"
                v-model="payload.keywords[i]"
                :placeholder="showPlaceholder !== i ? $t('chatbotv2.addKeyword') : ''"
            />
        </div>
        <div class="user-input-header">
            <span
                class="material-icons"
                v-tippy="{ followCursor: true, placement: 'top-center' }"
                content="User says is a matching system in ChatBot. This system analyzes the full user query to pair it with the chatbot response that matches the best."
            >
                help_outline
            </span>
            {{ $t("chatbotv2.userSays") }}
        </div>
        <div class="says">
            <!--            <input-->
            <!--                @blur="onBlur"-->
            <!--                class="say"-->
            <!--                type="text"-->
            <!--                v-for="(k, i) in payload.inputs"-->
            <!--                v-model="payload.inputs[i]"-->
            <!--                :placeholder="$t('chatbotv2.addUserMessage')"-->
            <!--            />-->
            <TiptapEditor
                :show-emoji="true"
                :show-attributes="true"
                :placeholder="$t('chatbotv2.addUserMessage')"
                :max-character-count="6200"
                v-for="(k, i) in payload.inputs"
                v-model="payload.inputs[i]"
                :key="'tiptap-' + i"
                :enter-enabled="false"
                :parameter-validation-mode="true"
                :omit-validation="['regex']"
            />
        </div>
        <div class="trigger-from-anywhere">
            <md-icon style="margin: 0">help</md-icon>
            <span> {{ $t("chatbotv2.triggerFromAnywhere") }} </span>
            <md-switch v-model="payload.triggerFromAnywhere" style="margin: 0" />
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";

export default {
    name: "UserInput",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        let payload = _.cloneDeep(this.value);
        if (_.last(payload.inputs) !== "") {
            payload.inputs = payload.inputs || [];
            payload.inputs.push("");
        }
        if (_.last(payload.keywords) !== "") {
            payload.keywords = payload.keywords || [];
            payload.keywords.push("");
        }
        if (payload.triggerFromAnywhere === undefined) payload.triggerFromAnywhere = false;
        return {
            showPlaceholder: true,
            payload,
        };
    },
    watch: {
        payload: {
            deep: true,
            handler(nV, oV) {
                if (!!nV) {
                    if (_.last(nV.keywords).length > 0) this.payload.keywords.push("");
                    if (_.slice(nV.keywords, 0, -1).some((x) => !x) && nV.keywords.length > 1) {
                        this.payload.keywords = nV.keywords.filter((x) => !!x);
                        this.payload.keywords.push("");
                    }
                    if (_.last(nV.inputs).length > 0) this.payload.inputs.push("");
                    if (_.slice(nV.inputs, 0, -1).some((x) => !x) && nV.inputs.length > 1) {
                        this.payload.inputs = nV.inputs.filter((x) => !!x);
                        this.payload.inputs.push("");
                    }
                }
                this.$emit("input", {
                    inputs: this.payload.inputs.filter((x) => !!x),
                    keywords: this.payload.keywords.filter((x) => !!x),
                    triggerFromAnywhere: this.payload.triggerFromAnywhere,
                });
            },
        },
    },
    methods: {
        onBlur() {
            this.showPlaceholder = -1;

            function hasDuplicates(a) {
                return _.uniq(a).length !== a.length;
            }

            if (hasDuplicates(this.payload.keywords)) this.payload.keywords = _.uniq(this.payload.keywords);
            if (hasDuplicates(this.payload.inputs)) this.payload.inputs = _.uniq(this.payload.inputs);
        },
    },
};
</script>

<style lang="scss">
.trigger-from-anywhere {
    align-items: center;
    background: #ccc;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    display: flex;
    height: 40px;
    padding: 0 30px;
    margin: 0 -21px -14px;

    span {
        margin-right: 15px;
        margin-left: 10px;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
    }
}

.block-editor.user-input {
    padding: 30px 30px 90px;

    .user-input-header {
        align-items: center;
        display: flex;
        font-size: 16px;
        font-weight: 600;
        line-height: 20px;
        margin-bottom: 16px;

        .material-icons {
            margin-right: 6px;
        }
    }

    .editable-editor-wrapper {
        border: 1px solid white;
        border-radius: 13px;
        max-height: 50px;

        .editable-editor {
            max-height: 50px;

            .ProseMirror {
                max-height: 50px;
                overflow-y: auto;
            }
        }

        &.focused {
            border-color: #006cff;
        }

        &:hover {
            border-color: #006cff;
        }
    }
}
</style>
